import {GoToCategory} from "../GoToItem";
import {useKeyDataStore} from "../../../api/KeyDataStore";
import {RemoteValue} from "../../../util/RemoteValue";
import {AppPages} from "../../../app-layout/AppPages";
import KeyIcon from "@mui/icons-material/Key";
import {useGoToItems} from "./useGoToItems";

export function useKeyDataGoToItems(): RemoteValue<GoToCategory> {
    const keys = useKeyDataStore(state => state.remoteValue);

    return useGoToItems(
        'Keys',
        AppPages.keys.requiredPermissions,
        keys,
        keys => keys.map(key => ({
            id: `key-${key.id}`,
            label: key.keyNumber.toString(),
            sublabel: key.transponderId ? `NFC: ${key.transponderId}` : undefined,
            icon: () => <KeyIcon sx={{width: 24, height: 24}}/>,
            url: pageUrl => pageUrl(AppPages.keys, {}, {search: String(key.keyNumber)}),
        })),
    );
}
